/**
 * Coerce a projected entity cell (rep_entity.data[field], typed `unknown`) to
 * the `string | null` shape ValueDiff renders. A fill-on-empty "before" is the
 * empty string `""` (BE guarantee, SC-2231) — ValueChip already treats `""`
 * and `null` identically (blank/placeholder), so a normally-impossible missing
 * key (→ null) degrades the same way. Non-strings are stringified defensively.
 */
export function stringifyCell(value: unknown): string | null {
  if (value == null) return null;
  if (typeof value === 'string') return value;
  return String(value);
}
